// import { useEffect, useState } from "react";
// import { CaretDownOutlined, WarningOutlined } from "@ant-design/icons";


// import {
//     ArrowLeftOutlined,
// } from '@ant-design/icons';
// import { DatePicker, } from 'antd';
// import { useHistory } from 'react-router-dom';
// import {
//     Card,
//     Space,
//     Slider, Input,
// } from "antd";
// import { Select } from 'antd';
// import Main from "../components/layout/Main";
// import Header from "../components/layout/Header";
// import {
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Line,
//     Tooltip,
//     LineChart,
//     ResponsiveContainer,
//     AreaChart, Area,
// } from "recharts";
// import { get } from "../Libraries/Ajax/HttpService";
// function TotalFlows() {
//     const [defaultOption, setDefaultOption] = useState("Past Year");

//     const { Option } = Select;
//     const [optionone, setOptionone] = useState(["non_potable"]);
//     const [optiononenew, setOptiononenew] = useState(["Days"]);

//     const [classcodepotablesupply, setClasscodepotablesupply] = useState(["ALL"]);
//     const [classcodepotabledemand, setClasscodepotabledemand] = useState(["ALL"]);
//     const [classcodetotalsupply, setClasscodetotalsupply] = useState(["ALL"]);
//     const [classcodetotaldemand, setClasscodetotaldemand] = useState(["ALL"]);
//     const [list, setList] = useState([]);
//     const [account, setAccount] = useState(null);
//     const [parameterone, setParameterone] = useState(null);
//     const [parametertwo, setParametertwo] = useState(null);
//     const [arrayData, setArrayData] = useState(null);
//     const [response, setResponse] = useState([]);
//     const [first, setfirst] = useState(false);
//     const [second, setSecond] = useState(false);
//     const [demand, setDemand] = useState(false);
//     const [Produced, setProduced] = useState(false);

//     const [supply, setSupply] = useState(false);
//     const [accountability, setAccountability] = useState(false);
//     const [slvalue, setSlvalue] = useState(1);
//     const arryDatas = [];
//     const accountNew = [];

//     const { RangePicker } = DatePicker;
//     let history = useHistory();


//     const onchange = (value, dateString) => {

//         setParameterone(dateString[0]);
//         setParametertwo(dateString[1]);

//     }
//     const toPercent = (decimal, fixed = 0) => `${(decimal * 100).toFixed(fixed)}%`;

//     const getPercent = (value, total) => {
//         const ratio = total > 0 ? value / total : 0;

//         return toPercent(ratio, 2);
//     };

//     const renderTooltipContent = (o) => {
//         const { payload, label } = o;
//         const total = payload?.reduce((result, entry) => result + entry.value, 0);
//         if (payload && payload.length) {
//             return (
//                 <div className="custom-tooltip">
//                     <p className="total">{`${label} (Total: ${total})`}</p>
//                     <ul className="list">
//                         {payload.map((entry, index) => (
//                             <li key={`item-${index}`} style={{ color: entry.color }}>
//                                 {`${entry.name}: ${entry.value}(${getPercent(entry.value, total)})`}
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             );
//         }
//         return null;
//     };
//     useEffect(() => {


//         if (defaultOption == "Custom" && parameterone != undefined && parametertwo != undefined && Produced == true) {
//             get(`apis/total_flow_produced?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`
//             )
//                 .then(res => {
//                     setResponse(res.data.data);
//                     setList(response.code_list);
//                     res.data.data.total_flow.map((x, i) => {
//                         // console.log(x);

//                         let Obj = {
//                             name: x[0]?.flow_date,
//                             optionnew: x[0]?.option,
//                             value: x[0]?.flow,
//                             option: x[0]?.option_month,

//                         };

//                         arryDatas.push(Obj);

//                         // console.log(arryDatas);



//                     });
//                     setArrayData(arryDatas);
//                 });




//         }
//         else {
//             if (defaultOption != "Custom" && parameterone == null && parametertwo == null && Produced == true) {
//                 get(`apis/total_flow_produced?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`

//                 ).then(res => {
//                     //   console.log(res.data.data.total_flow);

//                     setResponse(res.data.data);
//                     setList(response.code_list);
//                     res.data.data.total_flow.map((x, i) => {
//                         // console.log(x);

//                         let Obj = {
//                             name: x[0]?.flow_date,
//                             optionnew: x[0]?.option,
//                             value: x[0]?.flow,
//                             option: x[0]?.option_month,

//                         };

//                         arryDatas.push(Obj);

//                         // console.log(arryDatas);



//                     });
//                     setArrayData(arryDatas);
//                 });

//             }


//         }
//     }, [Produced, optionone, defaultOption, optiononenew, slvalue]);
//     useEffect(() => {


//         if (defaultOption == "Custom" && parameterone != undefined && parametertwo != undefined && supply == true) {
//             if (optionone == "potable") {
               

//                 get(`apis/total_flow_supply?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotablesupply}`
//                 )
//                     .then(res => {
//                         setResponse(res.data.data);
//                         setList(response.code_list);
//                         res.data.data.total_flow.map((x, i) => {
//                             // console.log(x);
//                             if (classcodepotablesupply == "ALL") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     COH: x[0]?.flow,
//                                     WELL: x[1]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }
                           
//                             else if ( classcodepotablesupply == "COH") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     COH: x[0]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }
                            
//                             else if ( classcodepotablesupply == "WELL") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     WELL: x[0]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }
//                             // console.log(arryDatas);



//                         });
//                         setArrayData(arryDatas);
//                     });


//             }
//             else if (optionone == "total") {
               

//                 get(`apis/total_flow_supply?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotalsupply}`
//                 )
//                     .then(res => {
//                         setResponse(res.data.data);
//                         setList(response.code_list);
//                         res.data.data.total_flow.map((x, i) => {
//                             // console.log(x);
                           
//                              if (classcodetotalsupply =="ALL" && optionone =="total") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     COH: x[0]?.flow,
//                                     NPS: x[1]?.flow,
//                                     WELL: x[2]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }
//                             else if (classcodetotalsupply =="COH") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     COH: x[0]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }
//                             else if (classcodetotalsupply == "NPS") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     NPS: x[0]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }
//                             else if (classcodetotalsupply == "WELL") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     WELL: x[0]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }
//                             // console.log(arryDatas);



//                         });
//                         setArrayData(arryDatas);
//                     });


//             }
            
//             else {
//                 get(`apis/total_flow_supply?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`
//                 )
//                     .then(res => {
//                         setResponse(res.data.data);
//                         setList(response.code_list);
//                         res.data.data.total_flow.map((x, i) => {
//                             console.log(x);

//                             let Obj = {
//                                 name: x[0]?.flow_date,
//                                 optionnew: x[0]?.option,
//                                 value: x[0]?.flow,
//                                 option: x[0]?.option_month,

//                             };

//                             arryDatas.push(Obj);

//                             // console.log(arryDatas);



//                         });
//                         setArrayData(arryDatas);
//                     });
//             }


//         }
//         else {
//             if (defaultOption != "Custom" && parameterone == null && parametertwo == null && supply == true) {
//                 if (optionone == "potable") {
                    
//                     get(`apis/total_flow_supply?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotablesupply}`

//                     ).then(res => {
//                         //   console.log(res.data.data.total_flow);

//                         setResponse(res.data.data);
//                         setList(response.code_list);
//                         res.data.data.total_flow.map((x, i) => {
//                             // console.log(x);
                           
//                              if (classcodepotablesupply == "ALL") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     COH: x[0]?.flow,
//                                     WELL: x[1]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }

//                             else if ( classcodepotablesupply == "COH") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     COH: x[0]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }
//                             else if (classcodepotablesupply == "WELL") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     WELL: x[0]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }
                           

//                             // console.log(arryDatas);



//                         });
//                         setArrayData(arryDatas);
//                     });
//                 }
//                else if (optionone == "total") {
                    
//                     get(`apis/total_flow_supply?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotalsupply}`

//                     ).then(res => {
//                         //   console.log(res.data.data.total_flow);

//                         setResponse(res.data.data);
//                         setList(response.code_list);
//                         res.data.data.total_flow.map((x, i) => {
//                             // console.log(x);
//                             if (classcodetotalsupply == "ALL") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     COH: x[0]?.flow,
//                                     NPS: x[1]?.flow,
//                                     WELL: x[2]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                                 console.log(arryDatas);
//                             }
                            

//                             else if (classcodetotalsupply == "COH" ) {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     COH: x[0]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }
//                             else if (classcodetotalsupply == "WELL") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     WELL: x[0]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }
//                             else if (classcodetotalsupply == "NPS") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     NPS: x[0]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }

//                             // console.log(arryDatas);



//                         });
//                         setArrayData(arryDatas);
//                     });
//                 }
//                 else {
//                     get(`apis/total_flow_supply?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`

//                     ).then(res => {
//                         //   console.log(res.data.data.total_flow);

//                         setResponse(res.data.data);
//                         setList(response.code_list);
//                         res.data.data.total_flow.map((x, i) => {
//                             // console.log(x);

//                             let Obj = {
//                                 name: x[0]?.flow_date,
//                                 optionnew: x[0]?.option,
//                                 value: x[0]?.flow,
//                                 option: x[0]?.option_month,

//                             };

//                             arryDatas.push(Obj);

//                             // console.log(arryDatas);



//                         });
//                         setArrayData(arryDatas);
//                     });
//                 }

//             }


//         }
//     }, [supply, optionone, defaultOption, optiononenew, slvalue, classcodetotalsupply, classcodepotablesupply]);

//     useEffect(() => {


//         if (defaultOption == "Custom" && parameterone != undefined && parametertwo != undefined && accountability == true) {


//             get(`apis/accountability?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`
//             )
//                 .then(res => {
//                     setResponse(res.data.data);
//                     setList(null);
//                     res.data.data.accountability.map((x, i) => {
//                         // console.log(x);

//                         let Obj = {
//                             name: x.flow_date,
//                             optionnew: x.option,
//                             value: x.accountability,
//                             option: x.option_month,

//                         };

//                         arryDatas.push(Obj);

//                         // console.log(arryDatas);



//                     });
//                     setArrayData(arryDatas);
//                 });




//         }
//         else {
//             if (defaultOption != "Custom" && parameterone == null && parametertwo == null && accountability == true) {

//                 get(`apis/accountability?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`

//                 ).then(res => {
//                     //   console.log(res.data.data.total_flow);

//                     setResponse(res.data.data);
//                     setList(null);
//                     res.data.data.accountability.map((x, i) => {
//                         // console.log(x);

//                         let Obj = {
//                             name: x.flow_date,
//                             optionnew: x.option,
//                             value: x.accountability,
//                             option: x.option_month,

//                         };

//                         arryDatas.push(Obj);

//                         // console.log(arryDatas);



//                     });
//                     setArrayData(arryDatas);
//                 });

//             }


//         }
//     }, [accountability, optionone, defaultOption, optiononenew, slvalue]);
//     useEffect(() => {


//         if (defaultOption == "Custom" && parameterone != undefined && parametertwo != undefined && demand == true) {

//             if (optionone == "potable") {
               

//                 get(`apis/total_flow_demand?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotabledemand}`
//                 )
//                     .then(res => {
//                         setResponse(res.data.data);
//                         setList(response.code_list);
//                         res.data.data.account_flow.map((x) => {
//                             var a = "#";

//                             let Obj = {
//                                 name: x.account_name,
//                                 sum: x.sum,
//                                 colour: "#" + Math.random().toString(16).slice(2, 8)

//                             };
//                             accountNew.push(Obj);
//                             setAccount(accountNew);



//                         });
//                         console.log(account);
//                         res.data.data.total_flow.map((x, i) => {
//                             // console.log(x);
                          
//                              if (classcodepotabledemand == "ALL" && optionone =="potable") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     potableDomestic: x[0]?.flow,
//                                     potableFire: x[1]?.flow,
//                                     potableIrrigation: x[2]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);

//                                 // console.log(arryDatas);

//                             }
//                             else {
//                                 let name = x[0]?.flow_date;
//                                 let optionnew = x[0]?.option;
//                                 let option = x[0]?.option_month;
//                                 const meterData = Object.fromEntries(
//                                     x?.map(({ account_name, flow }) => [account_name, flow]),

//                                 );

//                                 const weeklyMeterData = { name, optionnew, option, ...meterData };

//                                 arryDatas.push(weeklyMeterData);




//                                 // console.log("arryDatas", arryDatas);

//                             }

//                             // else if (classcode == "NPI") {
//                             //     let Obj = {
//                             //         name: x[0]?.flow_date,
//                             //         optionnew: x[0]?.option,
//                             //         NonPotableIrrigation: x[0]?.flow,
//                             //         option: x[0]?.option_month,

//                             //     };

//                             //     arryDatas.push(Obj);
//                             // }
//                             // else if (classcode == "PD") {
//                             //     let Obj = {
//                             //         name: x[0]?.flow_date,
//                             //         optionnew: x[0]?.option,
//                             //         potableDomestic: x[0]?.flow,
//                             //         option: x[0]?.option_month,

//                             //     };

//                             //     arryDatas.push(Obj);
//                             // }
//                             // else if (classcode == "PF") {
//                             //     let Obj = {
//                             //         name: x[0]?.flow_date,
//                             //         optionnew: x[0]?.option,
//                             //         potableFire: x[0]?.flow,
//                             //         option: x[0]?.option_month,

//                             //     };

//                             //     arryDatas.push(Obj);
//                             // }
//                             // else if (classcode == "PI") {
//                             //     let Obj = {
//                             //         name: x[0]?.flow_date,
//                             //         optionnew: x[0]?.option,
//                             //          potableIrrigation: x[0]?.flow,
//                             //         option: x[0]?.option_month,

//                             //     };

//                             //     arryDatas.push(Obj);
//                             // }
//                         });

//                         setArrayData(arryDatas);
//                     });



//             }
//            else if (optionone =="total") {
               

//                 get(`apis/total_flow_demand?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotaldemand}`
//                 )
//                     .then(res => {
//                         setResponse(res.data.data);
//                         setList(response.code_list);
//                         res.data.data.account_flow.map((x) => {
//                             var a = "#";

//                             let Obj = {
//                                 name: x.account_name,
//                                 sum: x.sum,
//                                 colour: "#" + Math.random().toString(16).slice(2, 8)

//                             };
//                             accountNew.push(Obj);
//                             setAccount(accountNew);



//                         });
//                         console.log(account);
//                         res.data.data.total_flow.map((x, i) => {
//                             // console.log(x);
//                             if (classcodetotaldemand == "ALL" && optionone == "total") {
//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     NonPotableIrrigation: x[0]?.flow,
//                                     potableDomestic: x[1]?.flow,
//                                     potableFire: x[2]?.flow,
//                                     potableIrrigation: x[3]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                                 console.log(arryDatas);
//                             }
                           
//                             else {
//                                 let name = x[0]?.flow_date;
//                                 let optionnew = x[0]?.option;
//                                 let option = x[0]?.option_month;
//                                 const meterData = Object.fromEntries(
//                                     x?.map(({ account_name, flow }) => [account_name, flow]),

//                                 );

//                                 const weeklyMeterData = { name, optionnew, option, ...meterData };

//                                 arryDatas.push(weeklyMeterData);




//                                 // console.log("arryDatas", arryDatas);

//                             }

//                             // else if (classcode == "NPI") {
//                             //     let Obj = {
//                             //         name: x[0]?.flow_date,
//                             //         optionnew: x[0]?.option,
//                             //         NonPotableIrrigation: x[0]?.flow,
//                             //         option: x[0]?.option_month,

//                             //     };

//                             //     arryDatas.push(Obj);
//                             // }
//                             // else if (classcode == "PD") {
//                             //     let Obj = {
//                             //         name: x[0]?.flow_date,
//                             //         optionnew: x[0]?.option,
//                             //         potableDomestic: x[0]?.flow,
//                             //         option: x[0]?.option_month,

//                             //     };

//                             //     arryDatas.push(Obj);
//                             // }
//                             // else if (classcode == "PF") {
//                             //     let Obj = {
//                             //         name: x[0]?.flow_date,
//                             //         optionnew: x[0]?.option,
//                             //         potableFire: x[0]?.flow,
//                             //         option: x[0]?.option_month,

//                             //     };

//                             //     arryDatas.push(Obj);
//                             // }
//                             // else if (classcode == "PI") {
//                             //     let Obj = {
//                             //         name: x[0]?.flow_date,
//                             //         optionnew: x[0]?.option,
//                             //          potableIrrigation: x[0]?.flow,
//                             //         option: x[0]?.option_month,

//                             //     };

//                             //     arryDatas.push(Obj);
//                             // }
//                         });

//                         setArrayData(arryDatas);
//                     });



//             }
//             else {
//                 get(`apis/total_flow_demand?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`
//                 )
//                     .then(res => {
//                         setResponse(res.data.data);
//                         setList(response.code_list);
//                         res.data.data.total_flow.map((x, i) => {
//                             // console.log(x);

//                             let Obj = {
//                                 name: x[0]?.flow_date,
//                                 optionnew: x[0]?.option,
//                                 value: x[0]?.flow,
//                                 option: x[0]?.option_month,

//                             };

//                             arryDatas.push(Obj);

//                             // console.log(arryDatas);



//                         });
//                         setArrayData(arryDatas);
//                     });

//             }

//         }
//         else {
//             if (defaultOption != "Custom" && parameterone == null && parametertwo == null && demand == true) {
//                 if (optionone == "potable") {
                   
//                     get(`apis/total_flow_demand?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotabledemand}`

//                     ).then(res => {
//                         //   console.log(res.data.data.total_flow);

//                         setResponse(res.data.data);
//                         setList(response.code_list);
//                         // console.log("code_list", list);
//                         // response.code_list.forEach((data) => {
//                         //     list.push(<h3 >{data}</h3>)

//                         //   })
//                         // console.log(res.data.data.account_flow);
//                         res.data.data.account_flow.map((x) => {
//                             var a = "#";

//                             let Obj = {
//                                 name: x.account_name,
//                                 sum: x.sum,
//                                 colour: "#" + Math.random().toString(16).slice(2, 8)

//                             };
//                             accountNew.push(Obj);
//                             setAccount(accountNew);



//                         });
//                         console.log(account);
//                         res.data.data.total_flow.map((x, i) => {
//                             // console.log(x);
//                             if (classcodepotabledemand=="ALL" && optionone=="potable") {

//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     potableDomestic: x[0]?.flow,
//                                     potableFire: x[1]?.flow,
//                                     potableIrrigation: x[2]?.flow,

//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                             }
                            

//                             else {
//                                 let name = x[0]?.flow_date;
//                                 let optionnew = x[0]?.option;
//                                 let option = x[0]?.option_month;
//                                 const meterData = Object.fromEntries(
//                                     x?.map(({ account_name, flow }) => [account_name, flow]),

//                                 );

//                                 const weeklyMeterData = { name, optionnew, option, ...meterData };

//                                 arryDatas.push(weeklyMeterData);




//                                 // console.log("arryDatas", arryDatas);

//                             }




//                         });
//                         setArrayData(arryDatas);
//                         console.log(arrayData);
//                     });

//                 }
//                 else if (optionone =="total") {
                   
//                     get(`apis/total_flow_demand?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotaldemand}`

//                     ).then(res => {
//                         //   console.log(res.data.data.total_flow);

//                         setResponse(res.data.data);
//                         setList(response.code_list);
//                         // console.log("code_list", list);
//                         // response.code_list.forEach((data) => {
//                         //     list.push(<h3 >{data}</h3>)

//                         //   })
//                         // console.log(res.data.data.account_flow);
//                         res.data.data.account_flow.map((x) => {
//                             var a = "#";

//                             let Obj = {
//                                 name: x.account_name,
//                                 sum: x.sum,
//                                 colour: "#" + Math.random().toString(16).slice(2, 8)

//                             };
//                             accountNew.push(Obj);
//                             setAccount(accountNew);



//                         });
//                         console.log(account);
//                         res.data.data.total_flow.map((x, i) => {
//                             // console.log(x);
                            
//                             if (classcodetotaldemand =="ALL" && optionone =="total") {

//                                 let Obj = {
//                                     name: x[0]?.flow_date,
//                                     optionnew: x[0]?.option,
//                                     NonPotableIrrigation: x[0]?.flow,
//                                     potableDomestic: x[1]?.flow,
//                                     potableFire: x[2]?.flow,
//                                     potableIrrigation: x[3]?.flow,
//                                     option: x[0]?.option_month,

//                                 };

//                                 arryDatas.push(Obj);
//                                 // console.log("bad",arryDatas);
//                             }

//                             else {
//                                 let name = x[0]?.flow_date;
//                                 let optionnew = x[0]?.option;
//                                 let option = x[0]?.option_month;
//                                 const meterData = Object.fromEntries(
//                                     x?.map(({ account_name, flow }) => [account_name, flow]),

//                                 );

//                                 const weeklyMeterData = { name, optionnew, option, ...meterData };

//                                 arryDatas.push(weeklyMeterData);




//                                 // console.log("arryDatas", arryDatas);

//                             }




//                         });
//                         setArrayData(arryDatas);
//                         console.log(arrayData);
//                     });

//                 }

//                 else {
//                     get(`apis/total_flow_demand?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`

//                     ).then(res => {
//                         //   console.log(res.data.data.total_flow);

//                         setResponse(res.data.data);
//                         setList(response.code_list);
//                         // console.log("code_list", list);
//                         // response.code_list.forEach((data) => {
//                         //     list.push(<h3 >{data}</h3>)

//                         //   })
//                         res.data.data.total_flow.map((x, i) => {
//                             // console.log(x);

//                             let Obj = {
//                                 name: x[0]?.flow_date,
//                                 optionnew: x[0]?.option,
//                                 value: x[0]?.flow,


//                                 option: x[0]?.option_month,

//                             };

//                             arryDatas.push(Obj);

//                             // console.log(arryDatas);



//                         });
//                         setArrayData(arryDatas);

//                     });


//                 }



//             }


//         }
//     }, [demand, optionone, defaultOption, optiononenew, slvalue, classcodepotabledemand, classcodetotaldemand]);
//     const sliderChange = (event) => {

//         setSlvalue(event);
//     }
//     const onMouseClick = event => {
//         setDefaultOption(event.target.value);

//     };
//     const radioChanges = event => {

//         setOptionone(event.target.value);


//     };
//     const radioChange = event => {
//         setOptiononenew(event.target.id);


//     };
//     const radioChangedroptotaldemand = event => {
//         setClasscodetotaldemand(event.target.id);


//     };
//     const radioChangedroptotalsupply = event => {
//         setClasscodetotalsupply(event.target.id);


//     };
//     const radioChangedroppotabledemand = event => {
//         setClasscodepotabledemand(event.target.id);


//     };
//     const radioChangedroppotablesupply = event => {
//         setClasscodepotablesupply(event.target.id);


//     };

//     const onRedirection = (event) => {

//         history.push('/dashboard');
//     }
//     const onselectClicks = () => {

//         setAccountability(true);
//         setProduced(false);
//         setDemand(false);
//         setSupply(false);
//     }
//     const onselectClicksupply = () => {

//         setSupply(true);
//         setAccountability(false);
//         setProduced(false);
//         setDemand(false);

//     }
//     const onselectClickdemand = () => {

//         setDemand(true);
//         setSupply(false);
//         setAccountability(false);
//         setProduced(false);

//     }
//     const onselectClickproduced = () => {
//         setDemand(false);
//         setSupply(false);
//         setAccountability(false);
//         setProduced(true);
//     }
//     const onselectClick = () => {
//         history.push('/outlierovertime');
//     }


//     return (
//         <>
//             <Header />
//             <Main>
//                 <div className="d-flex justify-content-between align-items-center">
//                     <h4 className="mb-0"><ArrowLeftOutlined onClick={onRedirection} />  Total Flow</h4>

//                 </div>


//                 <div className="bottom-layout">


//                     <div class="container-fluid pb-4 px-0 flex-column">
//                         <div class="row row-cols-3 g-3">

//                             <div className="col-12">


//                                 <Card bordered={false} className="checkStatusHealth">
//                                     <div className="fs-20 fw-bold">
//                                         <div className='d-flex gap-3 justify-content-between align-items-end  flex-wrap'>
//                                             <div className="d-flex flex-wrap">
//                                                 <div className='totalflow-width mt-0 me-2'>
//                                                     <div className='w-100 text-blue total-flow-font-size'>Date Range</div>
//                                                     <div id="1st" className="w-100 d-flex p-1 selectCalender ms-auto mt-0 water-space  align-items-center
//                                               justify-content-center" >
//                                                         <div className='d-flex w-100'>
//                                                             <div className="fs-26 fw-bold d-flex w-100 water">
//                                                                 <select name="All meters" id="selector" className="box" onChange={onMouseClick} >

//                                                                     <option value="Past Year" selected>Past Year</option>
//                                                                     <option value="Past 3 Months" >Past 3 Months </option>
//                                                                     <option value="Past Month">Past Month</option>
//                                                                     <option value="Past Week">Past Week</option>
//                                                                     <option value="Past Day">Past Day</option>
//                                                                     <option value="Custom">Custom</option>
//                                                                 </select>

//                                                             </div>
//                                                             <Space direction="horizontal" size={1} className="custom-date">

//                                                                 {defaultOption === "Custom" ? <RangePicker onChange={onchange} /> : ""}

//                                                             </Space>

//                                                         </div></div>
//                                                 </div>
//                                                 <div className='totalflow-width mt-0 me-2'>
//                                                     <div className='w-100 text-blue total-flow-font-size'>Interval</div>
//                                                     <div className="dropdown intervaldropdown">
//                                                         <button className="btn dropdown-toggle w-100 p-1" type="button"
//                                                             id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
//                                                             {optiononenew}
//                                                         </button>
//                                                         <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
//                                                             <li className="interdrop">

//                                                                 {optiononenew === "Hours" ? <Slider defaultValue={0} disabled={false} max={24} onAfterChange={sliderChange} /> : optiononenew === "Days" ? <Slider defaultValue={0} disabled={false} max={30} onAfterChange={sliderChange} /> : defaultOption === "Past Year" && optiononenew === "Weeks" ? <Slider defaultValue={0} disabled={false} max={52} onAfterChange={sliderChange} /> : defaultOption === "Past 3 Months" && optiononenew === "Weeks" ? <Slider defaultValue={0} disabled={false} max={6} onAfterChange={sliderChange} /> : defaultOption === "Past Month" && optiononenew === "Weeks" ? <Slider defaultValue={0} disabled={false} max={2} onAfterChange={sliderChange} /> : <Slider defaultValue={0} disabled={false} max={Math.floor(((new Date(parametertwo) - new Date(parameterone)) / (1000 * 60 * 60 * 24) / 7) / 2)} onAfterChange={sliderChange} />}



//                                                             </li>
//                                                             <li className="interdrop">
//                                                                 {defaultOption === "Past Year" ? "" : <div class="form-check d-flex align-items-center">
//                                                                     <Input className="form-check-input" type="radio" name="flexRadioDefault" id="Hours" onChange={radioChange} />
//                                                                     <label className="form-check-label" for="flexRadioDefault1">
//                                                                         Hours
//                                                                     </label>
//                                                                 </div>}


//                                                                 {defaultOption === "Past Day" ? "" : <div class="form-check d-flex align-items-center">
//                                                                     <Input className="form-check-input" type="radio" name="flexRadioDefault" defaultChecked='true' id="Days" onChange={radioChange} />
//                                                                     <label className="form-check-label" for="flexRadioDefault2">
//                                                                         Days
//                                                                     </label>
//                                                                 </div>
//                                                                 }
//                                                                 {defaultOption === "Past Week" || defaultOption === "Past Day" ? "" : <div className="form-check d-flex align-items-center">
//                                                                     <Input className="form-check-input" type="radio" name="flexRadioDefault" id="Weeks" onChange={radioChange} />
//                                                                     <label className="form-check-label" for="flexRadioDefault3">
//                                                                         Weeks
//                                                                     </label>
//                                                                 </div>
//                                                                 }
//                                                             </li>

//                                                         </ul>
//                                                     </div></div>
//                                                 <div className='totalflow-width mt-0 me-2'>
//                                                     <div className='w-100 text-blue total-flow-font-size'>System</div>
//                                                     {/* <div className="dropdown intervaldropdown"> */}
//                                                     {/* <button className="btn dropdown-toggle w-100 p-1" type="button"
//                                                             id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
//                                                             {optionone}
//                                                         </button> */}
//                                                     {/* <ul className="dropdown-menu p-2" aria-labelledby="dropdownMenuButton1">


//                                                             <li>

//                                                                 <Input className="form-check-input" type="radio" name="flexRadioDefaults" id="potable" onChange={radioChanges} />
//                                                                 <label className="form-check-label" for="flexRadioDefault3">
//                                                                     Potable
//                                                                 </label>


//                                                             </li>
//                                                             <li>

//                                                                 <Input className="form-check-input" type="radio" name="flexRadioDefaults" id="non_potable" onChange={radioChanges} />
//                                                                 <label className="form-check-label" for="flexRadioDefault3">
//                                                                     Non-Potable
//                                                                 </label>


//                                                             </li>

//                                                         </ul> */}
//                                                     <div className="w-100 d-flex p-1 selectCalender ms-auto mt-0 water-space  align-items-center
//                                               justify-content-center">
//                                                         <div className='d-flex w-100'>
//                                                             <div className="fs-26 fw-bold d-flex w-100 water">
//                                                                 <select name="All" id="selector" className="box" onChange={radioChanges} >

//                                                                     <option value="non_potable" selected >Non-Potable </option>
//                                                                     <option value="potable" >Potable</option>
//                                                                     <option value="total" >Total </option>
//                                                                 </select>
//                                                             </div>
//                                                         </div>
//                                                         {/* <select name="All" id="selector" className="intervaldropdown" onChange={radioChanges} >

//                                                                 <option value="potable" selected>Potable</option>
//                                                                 <option value="non_potable" >Non-Potable </option>
//                                                                 <option value="total" >Total </option>
//                                                             </select> */}
//                                                     </div>
//                                                     {/* </div> */}
//                                                 </div>
//                                             </div>
//                                             {optionone =="potable" || optionone =="total" ?
//                                                 <div className="d-flex flex-wrap">
//                                                     {accountability === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
//                                                         onClick={onselectClicks}
//                                                     >
//                                                         Accountability
//                                                     </div> : <div className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
//                                                         onClick={onselectClicks}
//                                                     >
//                                                         Accountability
//                                                     </div>}
//                                                     {supply === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
//                                                         onClick={onselectClicksupply}
//                                                     > Supply
//                                                     </div> : <div className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
//                                                         onClick={onselectClicksupply}
//                                                     >
//                                                         Supply
//                                                     </div>}
//                                                     {Produced === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
//                                                         onClick={onselectClickproduced}
//                                                     >
//                                                         Produced
//                                                     </div> : <div className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
//                                                         onClick={onselectClickproduced}
//                                                     >
//                                                         Produced
//                                                     </div>}
//                                                     {demand === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer"
//                                                         onClick={onselectClickdemand}
//                                                     > Demand
//                                                     </div> : <div className="px-3 py-1  mt-4 bg-white border rounded align-self-center c-pointer"
//                                                         onClick={onselectClickdemand}
//                                                     > Demand
//                                                     </div>}
//                                                 </div> :

//                                                 <div className="d-flex flex-wrap">

//                                                     {supply === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
//                                                         onClick={onselectClicksupply}
//                                                     > Supply
//                                                     </div> : <div className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
//                                                         onClick={onselectClicksupply}
//                                                     >
//                                                         Supply
//                                                     </div>}

//                                                     {demand === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer"
//                                                         onClick={onselectClickdemand}
//                                                     > Demand
//                                                     </div> : <div className="px-3 py-1  mt-4 bg-white border rounded align-self-center c-pointer"
//                                                         onClick={onselectClickdemand}
//                                                     > Demand
//                                                     </div>}
//                                                 </div>
//                                             }
//                                         </div>

//                                     </div>
//                                     <div className="row mt-5">
//                                         <div className="col-12 col-lg-9">
//                                             <div className="d-flex chartTab mb-0 justify-content-end">

//                                                 {/* {accountability===true?"": */}
//                                                 {response.code_list?.map(list => (
//                                                     <div className="form-check formStatus2">
//                                                         <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" defaultChecked={true} />
//                                                         <label className="form-check-label" for="flexCheckDefault">
//                                                             {list}

//                                                         </label>
//                                                     </div>
//                                                 ))}



//                                                 {/* } */}
//                                                 {/* <div className="form-check formStatus2">
//                                                     <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
//                                                     <label className="form-check-label" for="flexCheckChecked">
//                                                         Non-Potable Supply
//                                                     </label>
//                                                 </div>
//                                                 <div className="form-check formStatus3">
//                                                     <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault2" />
//                                                     <label className="form-check-label" for="flexCheckDefault2">
//                                                         Potable Irrigation
//                                                     </label>
//                                                 </div>
//                                                 <div className="form-check formStatus4">
//                                                     <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked2" />
//                                                     <label className="form-check-label" for="flexCheckChecked2">
//                                                         Potable Fire
//                                                     </label>
//                                                 </div> */}
//                                                 <br />

//                                             </div>

//                                             <div style={{ maxWidth: "100%", margin: "0 auto", height: "700px" }}
//                                                 className="totalflow-graph">
//                                                 <ResponsiveContainer width="100%" height="100%">
//                                                     <AreaChart
//                                                         width={500}
//                                                         height={400}
//                                                         data={arrayData}
//                                                         // stackOffset="expand"
//                                                         margin={{
//                                                             top: 10,
//                                                             right: 30,
//                                                             left: 10,
//                                                             bottom: 0,
//                                                         }}
//                                                     >
//                                                         <CartesianGrid strokeDasharray="3 3" />
//                                                         {/* <YAxis tickFormatter={toPercent} />
//                                                         <Tooltip content={renderTooltipContent} /> */}
                                                        
//                                                         <XAxis xAxisId="0" dataKey="name" tick={false} />
//                                                         <XAxis dataKey="optionnew" allowDuplicatedCategory={false} xAxisId="1" />
//                                                         <XAxis dataKey="option" allowDuplicatedCategory={false} xAxisId="2" />
//                                                         <YAxis/>
//                                                         <Tooltip/>
//                                                         {demand===true && (classcodetotaldemand=="ALL" && optionone==="total") ? <>
//                                                             <Area type="monotone" dataKey="potableDomestic" stackId="1" stroke="#8884d8" fill="#8884d8" />
//                                                             <Area type="monotone" dataKey="potableFire" stackId="1" stroke="#82ca9d" fill="#82ca9d" />
//                                                             <Area type="monotone" dataKey="potableIrrigation" stackId="1" stroke="#ffc658" fill="#ffc658" />
//                                                             <Area type="monotone" dataKey="NonPotableIrrigation" stackId="1" stroke="#00ffff" fill="#00ffff" /></>
//                                                             : demand ===true && (classcodepotabledemand=="ALL" && optionone=="potable") ? <>
//                                                                 <Area type="monotone" dataKey="potableDomestic" stackId="1" stroke="#8884d8" fill="#8884d8" />
//                                                                 <Area type="monotone" dataKey="potableFire" stackId="1" stroke="#82ca9d" fill="#82ca9d" />
//                                                                 <Area type="monotone" dataKey="potableIrrigation" stackId="1" stroke="#ffc658" fill="#ffc658" />
//                                                             </>
//                                                                 : demand===true && (optionone == "non_potable") ? <>
//                                                                     <Area type="monotone" dataKey="value" stackId="1" stroke="#8884d8" fill="#8884d8" />

//                                                                 </>
//                                                                     : demand===true ?
//                                                                         account?.map((item, index) => (

//                                                                             <Area type="monotone" dataKey={item.name} stackId="1" stroke={item.colour} fill={item.colour} />
//                                                                         )
//                                                                         )
//                                                                         : supply===true &&(optionone === "total" && classcodetotalsupply ==="ALL") ?
//                                                                             <>
//                                                                                 <Area type="monotone" dataKey="WELL" stackId="1" stroke="#82ca9d" fill="#82ca9d" />
//                                                                                 <Area type="monotone" dataKey="NPS" stackId="1" stroke="#ffc658" fill="#ffc658" />
//                                                                                 <Area type="monotone" dataKey="COH" stackId="1" stroke="#8884d8" fill="#8884d8" />


//                                                                             </>
//                                                                             : supply === true && optionone =="potable" && classcodepotablesupply==="COH" ?
//                                                                                 <Area type="monotone" dataKey="COH" stackId="1" stroke="#8884d8" fill="#8884d8" /> :
//                                                                                 // supply === true && optionone =="potable" && classcodepotablesupply=== "WELL" ?
//                                                                                 //     <Area type="monotone" dataKey="WELL" stackId="1" stroke="#82ca9d" fill="#82ca9d" /> :
//                                                                                     supply === true && optionone =="potable" && classcodepotablesupply==="WELL" ?
//                                                                                             <Area type="monotone" dataKey="WELL" stackId="1" stroke="#82ca9d" fill="#82ca9d" /> :
//                                                                                     supply === true && optionone =="total" && classcodetotalsupply==="COH" ?
//                                                                                         <Area type="monotone" dataKey="COH" stackId="1" stroke="#8884d8" fill="#8884d8" /> :
//                                                                                         supply === true && optionone =="total" && classcodetotalsupply=== "WELL" ?
//                                                                                             <Area type="monotone" dataKey="WELL" stackId="1" stroke="#82ca9d" fill="#82ca9d" /> :
//                                                                                             supply === true && optionone =="total" && classcodetotalsupply==="NPS" ?
//                                                                                                 <Area type="monotone" dataKey="NPS" stackId="1" stroke="#ffc658" fill="#ffc658" />
//                                                                                                 : supply === true && (optionone=="potable") ?
//                                                                                                     <>
//                                                                                                         <Area type="monotone" dataKey="COH" stackId="1" stroke="#8884d8" fill="#8884d8" />
//                                                                                                         <Area type="monotone" dataKey="WELL" stackId="1" stroke="#82ca9d" fill="#82ca9d" />

//                                                                                                     </>

//                                                                                                     :
//                                                                                                     <Area type="monotone" dataKey="value" stackId="1" stroke="#8884d8" fill="#8884d8" />}

//                                                     </AreaChart>
//                                                 </ResponsiveContainer>
//                                             </div>
//                                         </div>
//                                         {accountability === true ? <div className="col-12 col-lg-3 trenddemand mt-5 px-3">

//                                             <div className="d-flex justify-content-between">
//                                                 <span className="text-blue fs-15">Average</span>
//                                                 <span className="text-blue fs-15">{response.average}%</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between">
//                                                 <span className="text-blue fs-15">Maximum</span>
//                                                 <span className="text-blue fs-15">{response.maximum}%</span>
//                                             </div>
//                                             <div className="d-flex justify-content-between">
//                                                 <span className="text-blue fs-15">Minimum</span>
//                                                 <span className="text-blue fs-15">{response.minimum}%</span>
//                                             </div>


//                                         </div> :
//                                             supply === true && (optionone === "potable" || optionone === "total") ?
//                                                 <div className="col-12 col-lg-3 trenddemand px-3">
//                                                     <div className="col">
//                                                         <h5 className=" categories-div">Categories</h5>
//                                                         <ul className="mb-3 p-0">
//                                                             <li className="interdrop">
//                                                                 {optionone === "total" ?
//                                                                     <>
//                                                                         <div className="form-check d-flex align-items-center mt-15 px-6">
//                                                                             <Input className="form-check-input" type="radio" name="flexRadioDefaultdrop" id="ALL" defaultChecked='true' onChange={radioChangedroptotalsupply} />
//                                                                             <label className="form-check-label ms-2" for="ALL">
//                                                                                 All
//                                                                             </label>
//                                                                         </div>


//                                                                         <div class="form-check d-flex align-items-center">
//                                                                             <Input className="form-check-input" type="radio" name="flexRadioDefaultdrop" id="COH" onChange={radioChangedroptotalsupply} />
//                                                                             <label className="form-check-label ms-2" for="COH">
//                                                                                 City of Houston
//                                                                             </label>
//                                                                         </div>

//                                                                         <div className="form-check d-flex align-items-center">
//                                                                             <Input className="form-check-input" type="radio" name="flexRadioDefaultdrop" id="WELL" onChange={radioChangedroptotalsupply} />
//                                                                             <label className="form-check-label ms-2" for="WELL">
//                                                                                 Generation Park Well
//                                                                             </label>
//                                                                         </div>

//                                                                         <div className="form-check d-flex align-items-center">
//                                                                             <Input className="form-check-input" type="radio" name="flexRadioDefaultdrop" id="NPS" onChange={radioChangedroptotalsupply} />
//                                                                             <label className="form-check-label ms-2" for="NPS">
//                                                                                 Non Potable Supply
//                                                                             </label>
//                                                                         </div></> :
//                                                                     optionone === "potable" ?
//                                                                         <>
//                                                                             <div className="form-check d-flex align-items-center mt-15 px-6">
//                                                                                 <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotable" id="ALL" defaultChecked='true' onChange={radioChangedroppotablesupply} />
//                                                                                 <label className="form-check-label ms-2" for="ALL">
//                                                                                     All
//                                                                                 </label>
//                                                                             </div>


//                                                                             <div class="form-check d-flex align-items-center">
//                                                                                 <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotable" id="COH" onChange={radioChangedroppotablesupply} />
//                                                                                 <label className="form-check-label ms-2" for="COH">
//                                                                                     City of Houston
//                                                                                 </label>
//                                                                             </div>

//                                                                             <div className="form-check d-flex align-items-center">
//                                                                                 <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotable" id="WELL" onChange={radioChangedroppotablesupply} />
//                                                                                 <label className="form-check-label ms-2" for="WELL">
//                                                                                     Generation Park Well
//                                                                                 </label>
//                                                                             </div>

//                                                                         </> : ""
//                                                                 }
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <div className="d-flex justify-content-between">
//                                                         <h5 className="mb-0">Account</h5>
//                                                         <h5 className="mb-0">Gallons</h5>
//                                                     </div>
//                                                     <div className="d-flex justify-content-between">
//                                                         <span className="text-blue fs-15">Total</span>
//                                                         <span className="text-blue fs-15">{response.total}</span>
//                                                     </div>
//                                                     {response.account_flow?.map((person, index) => (
//                                                         <div className="d-flex justify-content-between mt-3 px-2 bg-flow">
//                                                             <p className="fs-15 mb-0">{person.account_name}</p>
//                                                             <p className="fs-15 mb-0">{person.sum}</p>
//                                                         </div>))}

//                                                 </div>
//                                                 :
//                                                 demand === true && (optionone == "potable" || optionone == "total") ?
//                                                     <div className="col-12 col-lg-3 trenddemand mt-5 px-3">
//                                                         <div className="col">
//                                                             <h5 className=" categories-div">Categories</h5>
//                                                             <ul className="mb-3 p-0">
//                                                                 <li className="interdrop">
//                                                                     {optionone === "total" ? <>
//                                                                         <div className="form-check d-flex align-items-center mt-15 px-6">
//                                                                             <Input className="form-check-input" type="radio" name="flexRadioDefaultdropd" id="ALL" defaultChecked='true' onChange={radioChangedroptotaldemand} />
//                                                                             <label className="form-check-label ms-2" for="ALL">
//                                                                                 All
//                                                                             </label>
//                                                                         </div>


//                                                                         <div class="form-check d-flex align-items-center">
//                                                                             <Input className="form-check-input" type="radio" name="flexRadioDefaultdropd" id="PI" onChange={radioChangedroptotaldemand} />
//                                                                             <label className="form-check-label ms-2" for="PI">
//                                                                                 Potable Irrigation
//                                                                             </label>
//                                                                         </div>

//                                                                         <div className="form-check d-flex align-items-center">
//                                                                             <Input className="form-check-input" type="radio" name="flexRadioDefaultdropd" id="PD" onChange={radioChangedroptotaldemand} />
//                                                                             <label className="form-check-label ms-2" for="PD">
//                                                                                 Potable Domestic
//                                                                             </label>
//                                                                         </div>
//                                                                         <div className="form-check d-flex align-items-center">
//                                                                             <Input className="form-check-input" type="radio" name="flexRadioDefaultdropd" id="PF" onChange={radioChangedroptotaldemand} />
//                                                                             <label className="form-check-label ms-2" for="PF">
//                                                                                 Potable Fire
//                                                                             </label>
//                                                                         </div>

//                                                                         <div className="form-check d-flex align-items-center">
//                                                                             <Input className="form-check-input" type="radio" name="flexRadioDefaultdropd" id="NPI" onChange={radioChangedroptotaldemand} />
//                                                                             <label className="form-check-label ms-2" for="NPI">
//                                                                                 Non-Potable Irrigation
//                                                                             </label>
//                                                                         </div></>
//                                                                         : optionone === "potable" ?
//                                                                             <>
//                                                                                 <div className="form-check d-flex align-items-center mt-15 px-6">
//                                                                                     <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotables" id="ALL" defaultChecked='true' onChange={radioChangedroppotabledemand} />
//                                                                                     <label className="form-check-label ms-2" for="ALL">
//                                                                                         All
//                                                                                     </label>
//                                                                                 </div>


//                                                                                 <div class="form-check d-flex align-items-center">
//                                                                                     <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotables" id="PI" onChange={radioChangedroppotabledemand} />
//                                                                                     <label className="form-check-label ms-2" for="PI">
//                                                                                         Potable Irrigation
//                                                                                     </label>
//                                                                                 </div>

//                                                                                 <div className="form-check d-flex align-items-center">
//                                                                                     <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotables" id="PD" onChange={radioChangedroppotabledemand} />
//                                                                                     <label className="form-check-label ms-2" for="PD">
//                                                                                         Potable Domestic
//                                                                                     </label>
//                                                                                 </div>
//                                                                                 <div className="form-check d-flex align-items-center">
//                                                                                     <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotables" id="PF" onChange={radioChangedroppotabledemand} />
//                                                                                     <label className="form-check-label ms-2" for="PF">
//                                                                                         Potable Fire
//                                                                                     </label>
//                                                                                 </div>
//                                                                             </> : ""
//                                                                     }
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                         <div className="d-flex justify-content-between">
//                                                             <h5 className="mb-0">Account</h5>
//                                                             <h5 className="mb-0">Gallons</h5>
//                                                         </div>
//                                                         <div className="d-flex justify-content-between">
//                                                             <span className="text-blue fs-15">Total</span>
//                                                             <span className="text-blue fs-15">{response.total}</span>
//                                                         </div>
//                                                         {account?.map((person, index) => (
//                                                             <div className="d-flex justify-content-between mt-3 px-2 bg-flow">
//                                                                 <div className="d-flex">
//                                                                     {classcodetotaldemand === "ALL" || classcodetotalsupply === "ALL" || classcodepotabledemand === "ALL" || classcodepotablesupply === "ALL" ?
//                                                                         "" : <div style={{ background: person.colour, width: "15px", height: "15px", marginRight: "15px" }}></div>}
//                                                                     <p className="fs-15 mb-0">{person.name}</p>
//                                                                 </div>
//                                                                 <p className="fs-15 mb-0">{person.sum}</p>
//                                                             </div>))}

//                                                     </div>
//                                                     :

//                                                     <div className="col-12 col-lg-3 trenddemand px-3">
//                                                         <div className="d-flex justify-content-between">
//                                                             <h5 className="mb-0">Account</h5>
//                                                             <h5 className="mb-0">Gallons</h5>
//                                                         </div>
//                                                         <div className="d-flex justify-content-between">
//                                                             <span className="text-blue fs-15">Total</span>
//                                                             <span className="text-blue fs-15">{response.total}</span>
//                                                         </div>
//                                                         {response.account_flow?.map((person, index) => (
//                                                             <div className="d-flex justify-content-between mt-3 px-2 bg-flow">
//                                                                 <p className="fs-15 mb-0">{person.account_name}</p>
//                                                                 <p className="fs-15 mb-0">{person.sum}</p>
//                                                             </div>))}

//                                                     </div>}
//                                     </div>

//                                 </Card>

//                             </div>
//                             <br />

//                             {/* </div> */}
//                         </div>
//                     </div>
//                 </div>
//                 <br />

//             </Main>
//         </>
//     );
// }

// export default TotalFlows;
import { useEffect, useState } from "react";
import { CaretDownOutlined, WarningOutlined, SwapOutlined } from "@ant-design/icons";


import {
    ArrowLeftOutlined,
} from '@ant-design/icons';
import { DatePicker, } from 'antd';
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import {
    Card,
    Space,
    Slider, Input,
} from "antd";
import { Select } from 'antd';
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Line,
    Tooltip,
    LineChart,
    ResponsiveContainer,
    AreaChart, Area,
} from "recharts";
import { get } from "../Libraries/Ajax/HttpService";
import back from '../assets/images/back.svg';
function TotalFlow() {
    const [defaultOption, setDefaultOption] = useState("Past Month");

    const { Option } = Select;
    const [optionone, setOptionone] = useState(["non_potable"]);
    const [optiononenew, setOptiononenew] = useState(["Days"]);

    const [classcodepotablesupply, setClasscodepotablesupply] = useState(["ALL"]);
    const [classcodepotabledemand, setClasscodepotabledemand] = useState(["ALL"]);
    const [classcodetotalsupply, setClasscodetotalsupply] = useState(["ALL"]);
    const [classcodetotaldemand, setClasscodetotaldemand] = useState(["ALL"]);
    const [list, setList] = useState([]);
    const [account, setAccount] = useState(null);
    const [parameterone, setParameterone] = useState(null);
    const [parametertwo, setParametertwo] = useState(null);
    const [arrayData, setArrayData] = useState(null);
    const [response, setResponse] = useState([]);
    const [first, setfirst] = useState(false);
    const [second, setSecond] = useState(false);
    const [demand, setDemand] = useState(false);
    const [Produced, setProduced] = useState(false);

    const [supply, setSupply] = useState(false);
    const [accountability, setAccountability] = useState(false);
    const [slvalue, setSlvalue] = useState(1);
    const arryDatas = [];
    const accountNew = [];

    const { RangePicker } = DatePicker;
    // let history = useHistory();
    const navigate = useNavigate();

    const onchange = (value, dateString) => {

        setParameterone(dateString[0]);
        setParametertwo(dateString[1]);

    }
    const toPercent = (decimal, fixed = 0) => `${(decimal * 100)}%`;
    
    const getPercent = (value, total) => {
        const ratio = total > 0 ? (value / total).toFixed(4) : 0;

        return toPercent(ratio, 2);
    };

    const renderTooltipContent = (o) => {
        const { payload, label } = o;
        const total = payload?.reduce((result, entry) => result + entry.value, 0);
        if (payload && payload.length) {
            return (
                <div className="custom-tooltip">
                    <p className="total">{`${label} (Total: ${total})`}</p>
                    <ul className="list">
                        {payload.map((entry, index) => (
                            <li key={`item-${index}`} style={{ color: entry.color }}>
                                {`${entry.name}: ${entry.value}(${getPercent(entry.value, total)})`}
                            </li>
                        ))}
                    </ul>
                </div>
            );
        }
        return null;
    };
    useEffect(() => {


        if (defaultOption == "Custom" && parameterone != undefined && parametertwo != undefined && Produced == true) {
            get(`apis/total_flow_produced?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`
            )
                .then(res => {
                    setResponse(res.data.data);
                    setList(response.code_list);
                    res.data.data.total_flow.map((x, i) => {
                        // console.log(x);

                        let Obj = {
                            name: x[0]?.flow_date,
                            optionnew: x[0]?.option,
                            value: x[0]?.flow,
                            option: x[0]?.option_month,

                        };

                        arryDatas.push(Obj);

                        // console.log(arryDatas);



                    });
                    setArrayData(arryDatas);
                });




        }
        else {
            if (defaultOption != "Custom" && parameterone == null && parametertwo == null && Produced == true) {
                get(`apis/total_flow_produced?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`

                ).then(res => {
                    //   console.log(res.data.data.total_flow);

                    setResponse(res.data.data);
                    setList(response.code_list);
                    res.data.data.total_flow.map((x, i) => {
                        // console.log(x);

                        let Obj = {
                            name: x[0]?.flow_date,
                            optionnew: x[0]?.option,
                            value: x[0]?.flow,
                            option: x[0]?.option_month,

                        };

                        arryDatas.push(Obj);

                        // console.log(arryDatas);



                    });
                    setArrayData(arryDatas);
                });

            }


        }
    }, [Produced, optionone, defaultOption, optiononenew, slvalue, parameterone, parametertwo]);
    useEffect(() => {


        if (defaultOption == "Custom" && parameterone != undefined && parametertwo != undefined && supply == true) {
            if (optionone == "potable") {


                get(`apis/total_flow_supply?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotablesupply}`
                )
                    .then(res => {
                        setResponse(res.data.data);
                        setList(response.code_list);
                        res.data.data.total_flow.map((x, i) => {
                            // console.log(x);
                            if (classcodepotablesupply == "ALL") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    COH: x[0]?.flow,
                                    WELL: x[1]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }

                            else if (classcodepotablesupply == "COH") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    COH: x[0]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }

                            else if (classcodepotablesupply == "WELL") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    WELL: x[0]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }
                            // console.log(arryDatas);



                        });
                        setArrayData(arryDatas);
                    });


            }
            else if (optionone == "total") {


                get(`apis/total_flow_supply?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotalsupply}`
                )
                    .then(res => {
                        setResponse(res.data.data);
                        setList(response.code_list);
                        res.data.data.total_flow.map((x, i) => {
                            // console.log(x);

                            if (classcodetotalsupply == "ALL" && optionone == "total") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    COH: x[0]?.flow,
                                    NPS: x[1]?.flow,
                                    WELL: x[2]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }
                            else if (classcodetotalsupply == "COH") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    COH: x[0]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }
                            else if (classcodetotalsupply == "NPS") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    NPS: x[0]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }
                            else if (classcodetotalsupply == "WELL") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    WELL: x[0]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }
                            // console.log(arryDatas);



                        });
                        setArrayData(arryDatas);
                    });


            }

            else {
                get(`apis/total_flow_supply?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`
                )
                    .then(res => {
                        setResponse(res.data.data);
                        setList(response.code_list);
                        res.data.data.total_flow.map((x, i) => {
                            console.log(x);

                            let Obj = {
                                name: x[0]?.flow_date,
                                optionnew: x[0]?.option,
                                value: x[0]?.flow,
                                option: x[0]?.option_month,

                            };

                            arryDatas.push(Obj);

                            // console.log(arryDatas);



                        });
                        setArrayData(arryDatas);
                    });
            }


        }
        else {
            if (defaultOption != "Custom" && parameterone == null && parametertwo == null && supply == true) {
                if (optionone == "potable") {

                    get(`apis/total_flow_supply?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotablesupply}`

                    ).then(res => {
                        //   console.log(res.data.data.total_flow);

                        setResponse(res.data.data);
                        setList(response.code_list);
                        res.data.data.total_flow.map((x, i) => {
                            // console.log(x);

                            if (classcodepotablesupply == "ALL") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    COH: x[0]?.flow,
                                    WELL: x[1]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }

                            else if (classcodepotablesupply == "COH") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    COH: x[0]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }
                            else if (classcodepotablesupply == "WELL") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    WELL: x[0]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }


                            console.log(arryDatas);



                        });
                        setArrayData(arryDatas);
                    });
                }
                else if (optionone == "total") {

                    get(`apis/total_flow_supply?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotalsupply}`

                    ).then(res => {
                        //   console.log(res.data.data.total_flow);

                        setResponse(res.data.data);
                        setList(response.code_list);
                        res.data.data.total_flow.map((x, i) => {
                            // console.log(x);
                            if (classcodetotalsupply == "ALL") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    COH: x[0]?.flow,
                                    NPS: x[1]?.flow,
                                    WELL: x[2]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                                console.log(arryDatas);
                            }


                            else if (classcodetotalsupply == "COH") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    COH: x[0]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }
                            else if (classcodetotalsupply == "WELL") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    WELL: x[0]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }
                            else if (classcodetotalsupply == "NPS") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    NPS: x[0]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }

                            // console.log(arryDatas);



                        });
                        setArrayData(arryDatas);
                    });
                }
                else {
                    get(`apis/total_flow_supply?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`

                    ).then(res => {
                        //   console.log(res.data.data.total_flow);

                        setResponse(res.data.data);
                        setList(response.code_list);
                        res.data.data.total_flow.map((x, i) => {
                            // console.log(x);

                            let Obj = {
                                name: x[0]?.flow_date,
                                optionnew: x[0]?.option,
                                value: x[0]?.flow,
                                option: x[0]?.option_month,

                            };

                            arryDatas.push(Obj);

                            // console.log(arryDatas);



                        });
                        setArrayData(arryDatas);
                    });
                }

            }


        }
    }, [supply, optionone, defaultOption, optiononenew, slvalue, classcodetotalsupply, classcodepotablesupply, parameterone, parametertwo]);

    useEffect(() => {


        if (defaultOption == "Custom" && parameterone != undefined && parametertwo != undefined && accountability == true) {


            get(`apis/accountability?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`
            )
                .then(res => {
                    setResponse(res.data.data);
                    setList(null);
                    res.data.data.accountability.map((x, i) => {
                        // console.log(x);

                        let Obj = {
                            name: x.flow_date,
                            optionnew: x.option,
                            value: x.accountability,
                            option: x.option_month,

                        };

                        arryDatas.push(Obj);

                        // console.log(arryDatas);



                    });
                    setArrayData(arryDatas);
                });




        }
        else {
            if (defaultOption != "Custom" && parameterone == null && parametertwo == null && accountability == true) {

                get(`apis/accountability?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`

                ).then(res => {
                    //   console.log(res.data.data.total_flow);

                    setResponse(res.data.data);
                    setList(null);
                    res.data.data.accountability.map((x, i) => {
                        // console.log(x);

                        let Obj = {
                            name: x.flow_date,
                            optionnew: x.option,
                            value: x.accountability,
                            option: x.option_month,

                        };

                        arryDatas.push(Obj);

                        // console.log(arryDatas);



                    });
                    setArrayData(arryDatas);
                });

            }


        }
    }, [accountability, optionone, defaultOption, optiononenew, slvalue, parameterone, parametertwo]);
    useEffect(() => {


        if (defaultOption == "Custom" && parameterone != undefined && parametertwo != undefined && demand == true) {

            if (optionone == "potable") {


                get(`apis/total_flow_demand?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotabledemand}`
                )
                    .then(res => {
                        setResponse(res.data.data);
                        setList(response.code_list);
                        res.data.data.account_flow.map((x) => {
                            var a = "#";

                            let Obj = {
                                name: x.account_name,
                                sum: x.sum,
                                colour: "#" + Math.random().toString(16).slice(2, 8)

                            };
                            accountNew.push(Obj);
                            setAccount(accountNew);



                        });
                        console.log(account);
                        res.data.data.total_flow.map((x, i) => {
                            // console.log(x);

                            if (classcodepotabledemand == "ALL" && optionone == "potable") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    potableDomestic: x[0]?.flow,
                                    potableFire: x[1]?.flow,
                                    potableIrrigation: x[2]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);

                                // console.log(arryDatas);

                            }
                            else {
                                let name = x[0]?.flow_date;
                                let optionnew = x[0]?.option;
                                let option = x[0]?.option_month;
                                const meterData = Object.fromEntries(
                                    x?.map(({ account_name, flow }) => [account_name, flow]),

                                );

                                const weeklyMeterData = { name, optionnew, option, ...meterData };

                                arryDatas.push(weeklyMeterData);




                                // console.log("arryDatas", arryDatas);

                            }

                            // else if (classcode == "NPI") {
                            //     let Obj = {
                            //         name: x[0]?.flow_date,
                            //         optionnew: x[0]?.option,
                            //         NonPotableIrrigation: x[0]?.flow,
                            //         option: x[0]?.option_month,

                            //     };

                            //     arryDatas.push(Obj);
                            // }
                            // else if (classcode == "PD") {
                            //     let Obj = {
                            //         name: x[0]?.flow_date,
                            //         optionnew: x[0]?.option,
                            //         potableDomestic: x[0]?.flow,
                            //         option: x[0]?.option_month,

                            //     };

                            //     arryDatas.push(Obj);
                            // }
                            // else if (classcode == "PF") {
                            //     let Obj = {
                            //         name: x[0]?.flow_date,
                            //         optionnew: x[0]?.option,
                            //         potableFire: x[0]?.flow,
                            //         option: x[0]?.option_month,

                            //     };

                            //     arryDatas.push(Obj);
                            // }
                            // else if (classcode == "PI") {
                            //     let Obj = {
                            //         name: x[0]?.flow_date,
                            //         optionnew: x[0]?.option,
                            //          potableIrrigation: x[0]?.flow,
                            //         option: x[0]?.option_month,

                            //     };

                            //     arryDatas.push(Obj);
                            // }
                        });

                        setArrayData(arryDatas);
                    });



            }
            else if (optionone == "total") {


                get(`apis/total_flow_demand?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotaldemand}`
                )
                    .then(res => {
                        setResponse(res.data.data);
                        setList(response.code_list);
                        res.data.data.account_flow.map((x) => {
                            var a = "#";

                            let Obj = {
                                name: x.account_name,
                                sum: x.sum,
                                colour: "#" + Math.random().toString(16).slice(2, 8)

                            };
                            accountNew.push(Obj);
                            setAccount(accountNew);



                        });
                        console.log(account);
                        res.data.data.total_flow.map((x, i) => {
                            // console.log(x);
                            if (classcodetotaldemand == "ALL" && optionone == "total") {
                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    NonPotableIrrigation: x[0]?.flow,
                                    potableDomestic: x[1]?.flow,
                                    potableFire: x[2]?.flow,
                                    potableIrrigation: x[3]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                                console.log(arryDatas);
                            }

                            else {
                                let name = x[0]?.flow_date;
                                let optionnew = x[0]?.option;
                                let option = x[0]?.option_month;
                                const meterData = Object.fromEntries(
                                    x?.map(({ account_name, flow }) => [account_name, flow]),

                                );

                                const weeklyMeterData = { name, optionnew, option, ...meterData };

                                arryDatas.push(weeklyMeterData);




                                // console.log("arryDatas", arryDatas);

                            }

                            // else if (classcode == "NPI") {
                            //     let Obj = {
                            //         name: x[0]?.flow_date,
                            //         optionnew: x[0]?.option,
                            //         NonPotableIrrigation: x[0]?.flow,
                            //         option: x[0]?.option_month,

                            //     };

                            //     arryDatas.push(Obj);
                            // }
                            // else if (classcode == "PD") {
                            //     let Obj = {
                            //         name: x[0]?.flow_date,
                            //         optionnew: x[0]?.option,
                            //         potableDomestic: x[0]?.flow,
                            //         option: x[0]?.option_month,

                            //     };

                            //     arryDatas.push(Obj);
                            // }
                            // else if (classcode == "PF") {
                            //     let Obj = {
                            //         name: x[0]?.flow_date,
                            //         optionnew: x[0]?.option,
                            //         potableFire: x[0]?.flow,
                            //         option: x[0]?.option_month,

                            //     };

                            //     arryDatas.push(Obj);
                            // }
                            // else if (classcode == "PI") {
                            //     let Obj = {
                            //         name: x[0]?.flow_date,
                            //         optionnew: x[0]?.option,
                            //          potableIrrigation: x[0]?.flow,
                            //         option: x[0]?.option_month,

                            //     };

                            //     arryDatas.push(Obj);
                            // }
                        });

                        setArrayData(arryDatas);
                    });



            }
            else {
                get(`apis/total_flow_demand?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`
                )
                    .then(res => {
                        setResponse(res.data.data);
                        setList(response.code_list);
                        res.data.data.total_flow.map((x, i) => {
                            // console.log(x);

                            let Obj = {
                                name: x[0]?.flow_date,
                                optionnew: x[0]?.option,
                                value: x[0]?.flow,
                                option: x[0]?.option_month,

                            };

                            arryDatas.push(Obj);

                            // console.log(arryDatas);



                        });
                        setArrayData(arryDatas);
                    });

            }

        }
        else {
            if (defaultOption != "Custom" && parameterone == null && parametertwo == null && demand == true) {
                if (optionone == "potable") {

                    get(`apis/total_flow_demand?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotabledemand}`

                    ).then(res => {
                        //   console.log(res.data.data.total_flow);

                        setResponse(res.data.data);
                        setList(response.code_list);
                        // console.log("code_list", list);
                        // response.code_list.forEach((data) => {
                        //     list.push(<h3 >{data}</h3>)

                        //   })
                        // console.log(res.data.data.account_flow);
                        res.data.data.account_flow.map((x) => {
                            var a = "#";

                            let Obj = {
                                name: x.account_name,
                                sum: x.sum,
                                colour: "#" + Math.random().toString(16).slice(2, 8)

                            };
                            accountNew.push(Obj);
                            setAccount(accountNew);



                        });
                        console.log(account);
                        res.data.data.total_flow.map((x, i) => {
                            // console.log(x);
                            if (classcodepotabledemand == "ALL" && optionone == "potable") {

                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    potableDomestic: x[0]?.flow,
                                    potableFire: x[1]?.flow,
                                    potableIrrigation: x[2]?.flow,

                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                            }


                            else {
                                let name = x[0]?.flow_date;
                                let optionnew = x[0]?.option;
                                let option = x[0]?.option_month;
                                const meterData = Object.fromEntries(
                                    x?.map(({ account_name, flow }) => [account_name, flow]),

                                );

                                const weeklyMeterData = { name, optionnew, option, ...meterData };

                                arryDatas.push(weeklyMeterData);




                                // console.log("arryDatas", arryDatas);

                            }




                        });
                        setArrayData(arryDatas);
                        console.log(arrayData);
                    });

                }
                else if (optionone == "total") {

                    get(`apis/total_flow_demand?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotaldemand}`

                    ).then(res => {
                        //   console.log(res.data.data.total_flow);

                        setResponse(res.data.data);
                        setList(response.code_list);
                        // console.log("code_list", list);
                        // response.code_list.forEach((data) => {
                        //     list.push(<h3 >{data}</h3>)

                        //   })
                        // console.log(res.data.data.account_flow);
                        res.data.data.account_flow.map((x) => {
                            var a = "#";

                            let Obj = {
                                name: x.account_name,
                                sum: x.sum,
                                colour: "#" + Math.random().toString(16).slice(2, 8)

                            };
                            accountNew.push(Obj);
                            setAccount(accountNew);



                        });
                        console.log(account);
                        res.data.data.total_flow.map((x, i) => {
                            // console.log(x);

                            if (classcodetotaldemand == "ALL" && optionone == "total") {

                                let Obj = {
                                    name: x[0]?.flow_date,
                                    optionnew: x[0]?.option,
                                    NonPotableIrrigation: x[0]?.flow,
                                    potableDomestic: x[1]?.flow,
                                    potableFire: x[2]?.flow,
                                    potableIrrigation: x[3]?.flow,
                                    option: x[0]?.option_month,

                                };

                                arryDatas.push(Obj);
                                // console.log("bad",arryDatas);
                            }

                            else {
                                let name = x[0]?.flow_date;
                                let optionnew = x[0]?.option;
                                let option = x[0]?.option_month;
                                const meterData = Object.fromEntries(
                                    x?.map(({ account_name, flow }) => [account_name, flow]),

                                );

                                const weeklyMeterData = { name, optionnew, option, ...meterData };

                                arryDatas.push(weeklyMeterData);




                                // console.log("arryDatas", arryDatas);

                            }




                        });
                        setArrayData(arryDatas);
                        console.log(arrayData);
                    });

                }

                else {
                    get(`apis/total_flow_demand?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`

                    ).then(res => {
                        //   console.log(res.data.data.total_flow);

                        setResponse(res.data.data);
                        setList(response.code_list);
                        // console.log("code_list", list);
                        // response.code_list.forEach((data) => {
                        //     list.push(<h3 >{data}</h3>)

                        //   })
                        res.data.data.total_flow.map((x, i) => {
                            // console.log(x);

                            let Obj = {
                                name: x[0]?.flow_date,
                                optionnew: x[0]?.option,
                                value: x[0]?.flow,


                                option: x[0]?.option_month,

                            };

                            arryDatas.push(Obj);

                            // console.log(arryDatas);



                        });
                        setArrayData(arryDatas);

                    });


                }



            }


        }
    }, [demand, optionone, defaultOption, optiononenew, slvalue, classcodepotabledemand, classcodetotaldemand, parameterone, parametertwo]);
    const sliderChange = (event) => {
        

        setSlvalue(event);
    }
    const onMouseClick = event => {
        setDefaultOption(event.target.value);

    };
    const radioChanges = event => {

        setOptionone(event.target.value);


    };
    const radioChange = event => {
        setOptiononenew(event.target.id);


    };
    const radioChangedroptotaldemand = event => {
        setClasscodetotaldemand(event.target.id);


    };
    const radioChangedroptotalsupply = event => {
        setClasscodetotalsupply(event.target.id);


    };
    const radioChangedroppotabledemand = event => {
        setClasscodepotabledemand(event.target.id);


    };
    const radioChangedroppotablesupply = event => {
        setClasscodepotablesupply(event.target.id);


    };

    const onRedirection = (event) => {

        navigate('/dashboard');
    }
    const onselectClicks = () => {

        setAccountability(true);
        setProduced(false);
        setDemand(false);
        setSupply(false);
    }
    const onselectClicksupply = () => {

        setSupply(true);
        setAccountability(false);
        setProduced(false);
        setDemand(false);

    }
    const onselectClickdemand = () => {

        setDemand(true);
        setSupply(false);
        setAccountability(false);
        setProduced(false);

    }
    const onselectClickproduced = () => {
        setDemand(false);
        setSupply(false);
        setAccountability(false);
        setProduced(true);
    }
    const onselectClick = () => {
         navigate('/outlierovertime');
    }


    return (
        <>
            <Header />
            <Main>
                {/* <div className="d-flex justify-content-between align-items-center">
                    <h4 className="mb-0"><ArrowLeftOutlined onClick={onRedirection} />  Total Flow</h4>

                </div> */}
                <div className="d-flex align-items-center mb-4">
                      
                        <img src={back} alt="" style={{width:'10px', cursor: 'pointer'}} onClick={onRedirection} />
                        <h3 className="mb-0 ms-3"> Total Flow</h3>
                        </div>


                <div className="bottom-layout">


                    <div class="container-fluid pb-4 px-0 flex-column">
                        <div class="row row-cols-3 g-3">

                            <div className="col-12">


                                <Card bordered={false} className="checkStatusHealth">
                                    <div className="fs-20 fw-bold">
                                        <div className='d-flex gap-3 justify-content-between align-items-end  flex-wrap'>
                                            <div className="d-flex flex-wrap">
                                                <div className='totalflow-width mt-0 me-2'>
                                                    <div className='w-100 text-blue total-flow-font-size'>Date Range</div>
                                                    <div id="1st" className="w-100 d-flex p-1 selectCalender ms-auto mt-0 water-space  align-items-center
                                              justify-content-center" >
                                                        <div className='d-flex w-100'>
                                                            <div className="fs-26 fw-bold d-flex water">
                                                                <select name="All meters" id="selector" className="box" onChange={onMouseClick} >

                                                                    <option value="Past Year" >Past Year</option>
                                                                    <option value="Past 3 Months" >Past 3 Months </option>
                                                                    <option value="Past Month" selected>Past Month</option>
                                                                    <option value="Past Week">Past Week</option>
                                                                    <option value="Past Day">Past Day</option>
                                                                    <option value="Custom">Custom</option>
                                                                </select>

                                                            </div>
                                                            <Space direction="horizontal" size={1} className="custom-date">

                                                                {defaultOption === "Custom" ? <RangePicker onChange={onchange}  separator={<SwapOutlined />} /> : ""}

                                                            </Space>

                                                        </div></div>
                                                </div>
                                                <div className='totalflow-width mt-0 me-2'>
                                                    <div className='w-100 text-blue total-flow-font-size'>Interval</div>
                                                    <div className="dropdown intervaldropdown">
                                                        <button className="btn dropdown-toggle w-100 p-1" type="button"
                                                            id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {optiononenew}
                                                        </button>
                                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                            <li className="interdrop">

                                                                {optiononenew === "Hours" ? <Slider  disabled={false} min={1} max={24} onAfterChange={sliderChange} /> : optiononenew == "Days" ? <Slider  disabled={false} min={1} max={30} onAfterChange={sliderChange} /> : defaultOption == "Past Year" && optiononenew == "Weeks" ? <Slider  disabled={false} min={1}  max={52} onAfterChange={sliderChange} /> : defaultOption == "Past 3 Months" && optiononenew == "Weeks" ? <Slider  disabled={false}  min={1} max={6} onAfterChange={sliderChange} /> : defaultOption == "Past Month" && optiononenew == "Weeks" ? <Slider  disabled={false}  min={1} max={2} onAfterChange={sliderChange} /> : <Slider  disabled={false} min={1}  max={Math.floor(((new Date(parametertwo) - new Date(parameterone)) / (1000 * 60 * 60 * 24) / 7) / 2)} onAfterChange={sliderChange} />}



                                                            </li>
                                                            <li className="interdrop">
                                                                {defaultOption === "Past Year" ? "" : <div class="form-check d-flex align-items-center">
                                                                    <Input className="form-check-input" type="radio" name="flexRadioDefault" id="Hours" onChange={radioChange} />
                                                                    <label className="form-check-label" for="flexRadioDefault1">
                                                                        Hours
                                                                    </label>
                                                                </div>}


                                                                {defaultOption === "Past Day" ? "" : <div class="form-check d-flex align-items-center">
                                                                    <Input className="form-check-input" type="radio" name="flexRadioDefault" defaultChecked='true' id="Days" onChange={radioChange} />
                                                                    <label className="form-check-label" for="flexRadioDefault2">
                                                                        Days
                                                                    </label>
                                                                </div>
                                                                }
                                                                {defaultOption === "Past Week" || defaultOption === "Past Day" ? "" : <div className="form-check d-flex align-items-center">
                                                                    <Input className="form-check-input" type="radio" name="flexRadioDefault" id="Weeks" onChange={radioChange} />
                                                                    <label className="form-check-label" for="flexRadioDefault3">
                                                                        Weeks
                                                                    </label>
                                                                </div>
                                                                }
                                                            </li>

                                                        </ul>
                                                    </div></div>
                                                <div className='totalflow-width mt-0 me-2'>
                                                    <div className='w-100 text-blue total-flow-font-size'>System</div>
                                                    {/* <div className="dropdown intervaldropdown"> */}
                                                    {/* <button className="btn dropdown-toggle w-100 p-1" type="button"
                                                            id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {optionone}
                                                        </button> */}
                                                    {/* <ul className="dropdown-menu p-2" aria-labelledby="dropdownMenuButton1">


                                                            <li>

                                                                <Input className="form-check-input" type="radio" name="flexRadioDefaults" id="potable" onChange={radioChanges} />
                                                                <label className="form-check-label" for="flexRadioDefault3">
                                                                    Potable
                                                                </label>


                                                            </li>
                                                            <li>

                                                                <Input className="form-check-input" type="radio" name="flexRadioDefaults" id="non_potable" onChange={radioChanges} />
                                                                <label className="form-check-label" for="flexRadioDefault3">
                                                                    Non-Potable
                                                                </label>


                                                            </li>

                                                        </ul> */}
                                                    <div className="w-100 d-flex p-1 selectCalender ms-auto mt-0 water-space  align-items-center
                                              justify-content-center">
                                                        <div className='d-flex w-100'>
                                                            <div className="fs-26 fw-bold d-flex w-100 water">
                                                                <select name="All" id="selector" className="box" onChange={radioChanges} >

                                                                    <option value="non_potable" selected >Non-Potable </option>
                                                                    <option value="potable" >Potable</option>
                                                                    <option value="total" >Total </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {/* <select name="All" id="selector" className="intervaldropdown" onChange={radioChanges} >

                                                                <option value="potable" selected>Potable</option>
                                                                <option value="non_potable" >Non-Potable </option>
                                                                <option value="total" >Total </option>
                                                            </select> */}
                                                    </div>
                                                    {/* </div> */}
                                                </div>
                                            </div>
                                            {optionone == "potable" || optionone == "total" ?
                                                <div className="d-flex flex-wrap">
                                                    {accountability === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                                        onClick={onselectClicks}
                                                    >
                                                        Accountability
                                                    </div> : <div className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                                        onClick={onselectClicks}
                                                    >
                                                        Accountability
                                                    </div>}
                                                    {supply === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                                        onClick={onselectClicksupply}
                                                    > Supply
                                                    </div> : <div className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                                        onClick={onselectClicksupply}
                                                    >
                                                        Supply
                                                    </div>}
                                                    {Produced === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                                        onClick={onselectClickproduced}
                                                    >
                                                        Produced
                                                    </div> : <div className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                                        onClick={onselectClickproduced}
                                                    >
                                                        Produced
                                                    </div>}
                                                    {demand === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer"
                                                        onClick={onselectClickdemand}
                                                    > Demand
                                                    </div> : <div className="px-3 py-1  mt-4 bg-white border rounded align-self-center c-pointer"
                                                        onClick={onselectClickdemand}
                                                    > Demand
                                                    </div>}
                                                </div> :

                                                <div className="d-flex flex-wrap">

                                                    {supply === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                                        onClick={onselectClicksupply}
                                                    > Supply
                                                    </div> : <div className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                                        onClick={onselectClicksupply}
                                                    >
                                                        Supply
                                                    </div>}

                                                    {demand === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer"
                                                        onClick={onselectClickdemand}
                                                    > Demand
                                                    </div> : <div className="px-3 py-1  mt-4 bg-white border rounded align-self-center c-pointer"
                                                        onClick={onselectClickdemand}
                                                    > Demand
                                                    </div>}
                                                </div>
                                            }
                                        </div>

                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-12 col-lg-9">
                                            <div className="d-flex chartTab mb-0 justify-content-end">

                                                {/* {accountability===true?"": */}
                                                {response.code_list?.map(list => (
                                                    <div className="form-check formStatus2">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" defaultChecked={true} />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            {list}

                                                        </label>
                                                    </div>
                                                ))}



                                                {/* } */}
                                                {/* <div className="form-check formStatus2">
                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                    <label className="form-check-label" for="flexCheckChecked">
                                                        Non-Potable Supply
                                                    </label>
                                                </div>
                                                <div className="form-check formStatus3">
                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault2" />
                                                    <label className="form-check-label" for="flexCheckDefault2">
                                                        Potable Irrigation
                                                    </label>
                                                </div>
                                                <div className="form-check formStatus4">
                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked2" />
                                                    <label className="form-check-label" for="flexCheckChecked2">
                                                        Potable Fire
                                                    </label>
                                                </div> */}
                                                <br />

                                            </div>

                                            <div style={{ maxWidth: "100%", margin: "0 auto", height: "700px" }}
                                                className="totalflow-graph">
                                                
                                                    <ResponsiveContainer width="100%" height="100%">

                                                        <AreaChart
                                                            width={500}
                                                            height={400}
                                                            data={arrayData}
                                                            stackOffset="expand"
                                                            margin={{
                                                                top: 10,
                                                                right: 30,
                                                                left: 10,
                                                                bottom: 0,
                                                            }}
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <YAxis tickFormatter={toPercent} />
                                                            <Tooltip content={renderTooltipContent} />
                                                            <XAxis xAxisId="0" dataKey="name" tick={false} />
                                                            <XAxis dataKey="optionnew" allowDuplicatedCategory={false} xAxisId="1" />
                                                            <XAxis dataKey="option" allowDuplicatedCategory={false} xAxisId="2" />
                                                            {/* <YAxis />
                                                        <Tooltip /> */}
                                                            {demand === true && (classcodetotaldemand == "ALL" && optionone === "total") ? <>
                                                                <Area type="monotone" dataKey="potableDomestic" stackId="1" stroke="#8884d8" fill="#8884d8" />
                                                                <Area type="monotone" dataKey="potableFire" stackId="1" stroke="#82ca9d" fill="#82ca9d" />
                                                                <Area type="monotone" dataKey="potableIrrigation" stackId="1" stroke="#ffc658" fill="#ffc658" />
                                                                <Area type="monotone" dataKey="NonPotableIrrigation" stackId="1" stroke="#00ffff" fill="#00ffff" /></>
                                                                : demand === true && (classcodepotabledemand == "ALL" && optionone == "potable") ? <>
                                                                    <Area type="monotone" dataKey="potableDomestic" stackId="1" stroke="#8884d8" fill="#8884d8" />
                                                                    <Area type="monotone" dataKey="potableFire" stackId="1" stroke="#82ca9d" fill="#82ca9d" />
                                                                    <Area type="monotone" dataKey="potableIrrigation" stackId="1" stroke="#ffc658" fill="#ffc658" />
                                                                </>
                                                                    : demand === true && (optionone == "non_potable") ? <>
                                                                        <Area type="monotone" dataKey="value" stackId="1" stroke="#8884d8" fill="#8884d8" />

                                                                    </>
                                                                        : demand === true ?
                                                                            account?.map((item, index) => (

                                                                                <Area type="monotone" dataKey={item.name} stackId="1" stroke={item.colour} fill={item.colour} />
                                                                            )
                                                                            )

                                                                            : supply === true && optionone == "total" && classcodetotalsupply === "COH" ?
                                                                                <Area type="monotone" dataKey="COH" stackId="1" stroke="#8884d8" fill="#8884d8" /> :
                                                                                supply === true && optionone == "total" && classcodetotalsupply === "WELL" ?
                                                                                    <Area type="monotone" dataKey="WELL" stackId="1" stroke="#82ca9d" fill="#82ca9d" /> :
                                                                                    supply === true && optionone == "total" && classcodetotalsupply === "NPS" ?
                                                                                        <Area type="monotone" dataKey="NPS" stackId="1" stroke="#ffc658" fill="#ffc658" />
                                                                                        : supply === true && (optionone === "total") ?
                                                                                            <>
                                                                                                <Area type="monotone" dataKey="WELL" stackId="1" stroke="#82ca9d" fill="#82ca9d" />
                                                                                                <Area type="monotone" dataKey="NPS" stackId="1" stroke="#ffc658" fill="#ffc658" />
                                                                                                <Area type="monotone" dataKey="COH" stackId="1" stroke="#8884d8" fill="#8884d8" />


                                                                                            </>
                                                                                            : supply === true && optionone == "potable" && classcodepotablesupply === "COH" ?
                                                                                                <Area type="monotone" dataKey="COH" stackId="1" stroke="#8884d8" fill="#8884d8" /> :
                                                                                                // supply === true && optionone =="potable" && classcodepotablesupply=== "WELL" ?
                                                                                                //     <Area type="monotone" dataKey="WELL" stackId="1" stroke="#82ca9d" fill="#82ca9d" /> :
                                                                                                supply === true && optionone == "potable" && classcodepotablesupply === "WELL" ?
                                                                                                    <Area type="monotone" dataKey="WELL" stackId="1" stroke="#82ca9d" fill="#82ca9d" />

                                                                                                    : supply === true && (optionone == "potable") ?
                                                                                                        <>
                                                                                                            <Area type="monotone" dataKey="COH" stackId="1" stroke="#8884d8" fill="#8884d8" />
                                                                                                            <Area type="monotone" dataKey="WELL" stackId="1" stroke="#82ca9d" fill="#82ca9d" />

                                                                                                        </>

                                                                                                        :
                                                                                                        <Area type="monotone" dataKey="value" stackId="1" stroke="#8884d8" fill="#8884d8" />}

                                                        </AreaChart>
                                                    </ResponsiveContainer> 
                                              
                                            </div>
                                        </div>
                                        {accountability === true ? <div className="col-12 col-lg-3 trenddemand mt-5 px-3">

                                            <div className="d-flex justify-content-between">
                                                <span className="text-blue fs-15">Average</span>
                                                <span className="text-blue fs-15">{response.average}%</span>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                <span className="text-blue fs-15">Maximum</span>
                                                <span className="text-blue fs-15">{response.maximum}%</span>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                <span className="text-blue fs-15">Minimum</span>
                                                <span className="text-blue fs-15">{response.minimum}%</span>
                                            </div>


                                        </div> :
                                            supply === true && (optionone === "potable" || optionone === "total") ?
                                                <div className="col-12 col-lg-3 trenddemand px-3">
                                                    <div className="col">
                                                        <h5 className=" categories-div">Categories</h5>
                                                        <ul className="mb-3 p-0">
                                                            <li className="interdrop">
                                                                {optionone === "total" ?
                                                                    <>
                                                                        <div className="form-check d-flex align-items-center mt-15 px-6">
                                                                            <Input className="form-check-input" type="radio" name="flexRadioDefaultdrop" id="ALL" defaultChecked='true' onChange={radioChangedroptotalsupply} />
                                                                            <label className="form-check-label ms-2" for="ALL">
                                                                                All
                                                                            </label>
                                                                        </div>


                                                                        <div class="form-check d-flex align-items-center">
                                                                            <Input className="form-check-input" type="radio" name="flexRadioDefaultdrop" id="COH" onChange={radioChangedroptotalsupply} checked={classcodetotalsupply === 'COH'} />
                                                                            <label className="form-check-label ms-2" for="COH">
                                                                                City of Houston
                                                                            </label>
                                                                        </div>

                                                                        <div className="form-check d-flex align-items-center">
                                                                            <Input className="form-check-input" type="radio" name="flexRadioDefaultdrop" id="WELL" onChange={radioChangedroptotalsupply} checked={classcodetotalsupply === 'WELL'} />
                                                                            <label className="form-check-label ms-2" for="WELL">
                                                                                Generation Park Well
                                                                            </label>
                                                                        </div>

                                                                        <div className="form-check d-flex align-items-center">
                                                                            <Input className="form-check-input" type="radio" name="flexRadioDefaultdrop" id="NPS" onChange={radioChangedroptotalsupply} checked={classcodetotalsupply === 'NPS'} />
                                                                            <label className="form-check-label ms-2" for="NPS">
                                                                                Non Potable Supply
                                                                            </label>
                                                                        </div></> :
                                                                    optionone === "potable" ?
                                                                        <>
                                                                            <div className="form-check d-flex align-items-center mt-15 px-6">
                                                                                <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotable" id="ALL" onChange={radioChangedroppotablesupply} defaultChecked='true' />
                                                                                <label className="form-check-label ms-2" for="ALL">
                                                                                    All
                                                                                </label>
                                                                            </div>


                                                                            <div class="form-check d-flex align-items-center">
                                                                                <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotable" id="COH" onChange={radioChangedroppotablesupply} checked={classcodepotablesupply === 'COH'} />
                                                                                <label className="form-check-label ms-2" for="COH">
                                                                                    City of Houston
                                                                                </label>
                                                                            </div>

                                                                            <div className="form-check d-flex align-items-center">
                                                                                <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotable" id="WELL" onChange={radioChangedroppotablesupply} checked={classcodepotablesupply === 'WELL'} />
                                                                                <label className="form-check-label ms-2" for="WELL">
                                                                                    Generation Park Well
                                                                                </label>
                                                                            </div>

                                                                        </> : ""
                                                                }
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <h5 className="mb-0">Account</h5>
                                                        <h5 className="mb-0">Gallons</h5>
                                                    </div>
                                                    <div className="d-flex justify-content-between mt-2">
                                                        <span className="text-blue fs-15">Total</span>
                                                        <span className="text-blue fs-15">{response.total}</span>
                                                    </div>
                                                    {response.account_flow?.map((person, index) => (
                                                        <div className="d-flex justify-content-between mt-3 px-2 bg-flow">
                                                            <p className="fs-15 mb-0">{person.account_name}</p>
                                                            <p className="fs-15 mb-0">{person.sum}</p>
                                                        </div>))}

                                                </div>
                                                :
                                                demand === true && (optionone === "potable" || optionone === "total") ?
                                                    <div className="col-12 col-lg-3 trenddemand mt-5 px-3">
                                                        <div className="col">
                                                            <h5 className=" categories-div">Categories</h5>
                                                            <ul className="mb-3 p-0">
                                                                <li className="interdrop">
                                                                    {optionone === "total" ? <>
                                                                        <div className="form-check d-flex align-items-center mt-15 px-6">
                                                                            <Input className="form-check-input" type="radio" name="flexRadioDefaultdropd" id="ALL" onChange={radioChangedroptotaldemand} defaultChecked='true' />
                                                                            <label className="form-check-label ms-2" for="ALL">
                                                                                All
                                                                            </label>
                                                                        </div>


                                                                        <div class="form-check d-flex align-items-center">
                                                                            <Input className="form-check-input" type="radio" name="flexRadioDefaultdropd" id="PI" onChange={radioChangedroptotaldemand} checked={classcodetotaldemand === 'PI'} />
                                                                            <label className="form-check-label ms-2" for="PI">
                                                                                Potable Irrigation
                                                                            </label>
                                                                        </div>

                                                                        <div className="form-check d-flex align-items-center">
                                                                            <Input className="form-check-input" type="radio" name="flexRadioDefaultdropd" id="PD" onChange={radioChangedroptotaldemand} checked={classcodetotaldemand === 'PD'} />
                                                                            <label className="form-check-label ms-2" for="PD">
                                                                                Potable Domestic
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check d-flex align-items-center">
                                                                            <Input className="form-check-input" type="radio" name="flexRadioDefaultdropd" id="PF" onChange={radioChangedroptotaldemand} checked={classcodetotaldemand === 'PF'} />
                                                                            <label className="form-check-label ms-2" for="PF">
                                                                                Potable Fire
                                                                            </label>
                                                                        </div>

                                                                        <div className="form-check d-flex align-items-center">
                                                                            <Input className="form-check-input" type="radio" name="flexRadioDefaultdropd" id="NPI" onChange={radioChangedroptotaldemand} checked={classcodetotaldemand === 'NPI'} />
                                                                            <label className="form-check-label ms-2" for="NPI">
                                                                                Non-Potable Irrigation
                                                                            </label>
                                                                        </div></>
                                                                        : optionone === "potable" ?
                                                                            <>
                                                                                <div className="form-check d-flex align-items-center mt-15 px-6">
                                                                                    <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotables" id="ALL" onChange={radioChangedroppotabledemand} defaultChecked='true' />
                                                                                    <label className="form-check-label ms-2" for="ALL">
                                                                                        All
                                                                                    </label>
                                                                                </div>


                                                                                <div class="form-check d-flex align-items-center">
                                                                                    <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotables" id="PI" onChange={radioChangedroppotabledemand} checked={classcodepotabledemand === 'PI'} />
                                                                                    <label className="form-check-label ms-2" for="PI">
                                                                                        Potable Irrigation
                                                                                    </label>
                                                                                </div>

                                                                                <div className="form-check d-flex align-items-center">
                                                                                    <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotables" id="PD" onChange={radioChangedroppotabledemand} checked={classcodepotabledemand === 'PD'} />
                                                                                    <label className="form-check-label ms-2" for="PD">
                                                                                        Potable Domestic
                                                                                    </label>
                                                                                </div>
                                                                                <div className="form-check d-flex align-items-center">
                                                                                    <Input className="form-check-input" type="radio" name="flexRadioDefaultdroppotables" id="PF" onChange={radioChangedroppotabledemand} checked={classcodepotabledemand === 'PF'} />
                                                                                    <label className="form-check-label ms-2" for="PF">
                                                                                        Potable Fire
                                                                                    </label>
                                                                                </div>
                                                                            </> : ""
                                                                    }
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <h5 className="mb-0">Account</h5>
                                                            <h5 className="mb-0">Gallons</h5>
                                                        </div>
                                                        <div className="d-flex justify-content-between mt-2">
                                                            <span className="text-blue fs-15">Total</span>
                                                            <span className="text-blue fs-15">{response.total}</span>
                                                        </div>
                                                        {account?.map((person, index) => (
                                                            <div className="d-flex justify-content-between mt-3 px-2 bg-flow">
                                                                <div className="d-flex">
                                                                    {(classcodepotabledemand === "ALL" || classcodetotaldemand === "ALL" || classcodetotalsupply === "ALL" || classcodepotablesupply === "ALL") ?
                                                                        "" :
                                                                        (classcodetotaldemand === "PI" || classcodetotaldemand === "PD" || classcodetotaldemand ==="PF" || classcodetotaldemand === "NPI") ?
                                                                            <div style={{ background: person.colour, width: "15px", height: "15px", marginRight: "15px" }}></div> :
                                                                         (classcodepotabledemand === "PI" || classcodepotabledemand === "PD" || classcodepotabledemand === "PF") ?
                                                                                <div style={{ background: person.colour, width: "15px", height: "15px", marginRight: "15px" }}></div> 
                                                                                 : ""
                                                                                }
                                                                    <p className="fs-15 mb-0">{person.name}</p>
                                                                </div>
                                                                <p className="fs-15 mb-0">{person.sum}</p>
                                                            </div>))}

                                                    </div>
                                                    :

                                                    <div className="col-12 col-lg-3 trenddemand px-3">
                                                        <div className="d-flex justify-content-between">
                                                            <h5 className="mb-0">Account</h5>
                                                            <h5 className="mb-0">Gallons</h5>
                                                        </div>
                                                        <div className="d-flex justify-content-between mt-2">
                                                            <span className="text-blue fs-15">Total</span>
                                                            <span className="text-blue fs-15">{response.total}</span>
                                                        </div>
                                                        {response.account_flow?.map((person, index) => (
                                                            <div className="d-flex justify-content-between mt-3 px-2 bg-flow">
                                                                <p className="fs-15 mb-0">{person.account_name}</p>
                                                                <p className="fs-15 mb-0">{person.sum}</p>
                                                            </div>))}

                                                    </div>}
                                    </div>

                                </Card>

                            </div>
                            <br />

                            {/* </div> */}
                        </div>
                    </div>
                </div>
                <br />

            </Main>
        </>
    );
}

export default TotalFlow;
